// src/utils/otp.ts — Utilidades de OTP (login POW 2FA)

export const OTP_LENGTH = 6

/**
 * Distribuye un texto pegado en las cajas del OTP.
 * - Quita todo lo no numérico (espacios, guiones, letras).
 * - Si trae `OTP_LENGTH` o más dígitos → rellena desde la caja 0 (primeros 6).
 * - Si trae menos → rellena desde `startIndex`, sin salirse de las cajas.
 */
export function distribuirOtpPegado(
  pegado: string,
  actual: string[],
  startIndex: number,
): string[] {
  const digits = String(pegado ?? '').replace(/\D/g, '')
  const next = [...actual]
  while (next.length < OTP_LENGTH) next.push('')
  const start = digits.length >= OTP_LENGTH ? 0 : Math.max(0, Math.min(startIndex, OTP_LENGTH - 1))
  for (let k = 0; k < digits.length && start + k < OTP_LENGTH; k++) {
    next[start + k] = digits[k]
  }
  return next.slice(0, OTP_LENGTH)
}
